import ApiService, { HTTPMethod } from "./api.core"
import { Transformer } from "../models/Transformer"


class PolicyManagementImpersonationApi {

    async modifyExistingHull(insuranceId, drones, equipment) {
        let res = await ApiService.fetch(`insurances/${insuranceId}`, HTTPMethod.PUT, {
          insured_drone_list: drones, 
          insured_equipment_list: equipment
        })
        res.parsedData = Transformer.parseActiveInsuranceModel(res.data)
        return res;
    }

    async deleteDroneOrEquipmentFromHull(insuranceId, drone, equipment) {
      let res = await ApiService.fetch(`insurances/${insuranceId}/delete/drone_equipment`, HTTPMethod.DELETE, {
        insured_drone_to_remove: drone,
        insured_equipment_to_remove: equipment
      })
      if(res.ok) {
        res.parsedData = Transformer.parseActiveInsuranceModel(res.data)
      }
      return res;
    }

    async generateAcordEndorsement(insuranceId, additionalInsuredId, endorsementText) {      
      return await ApiService.fetch(`modify/insurance/${insuranceId}/acordAdditionalInsuredGenerateEndorsement`, HTTPMethod.POST, {
        additional_insured_id: additionalInsuredId,
        additional_description: endorsementText,
      })
    }

    async generateAdditionalEndorsement(insuranceId, additionalInsuredId, endorsementText) {      
      return await ApiService.fetch(`modify/insurance/additionalInsuredGenerateEndorsement/${insuranceId}`, HTTPMethod.POST, {
        additional_insured_id: additionalInsuredId,
        additional_description: endorsementText,
      })
    }

    async generateAdditionalEndorsementStar(insuranceId, additionalInsuredId, endorsementText, isExtended) {
      return await ApiService.fetch(`insurances/${insuranceId}/extensions/additional_insured/${isExtended}`, HTTPMethod.POST, {
        additional_insured_id: additionalInsuredId,
        additional_description: endorsementText,
    })
  }

    async submitManualEndorsement (insuranceId, values, endorsementFile) {
      var form = new FormData();
      form.append("EndorsementFile", endorsementFile, endorsementFile.name)
      form.append("InsuranceId", insuranceId)
      form.append("EndorsementName", values.endorsement_name)
      form.append("EndorsementRevision", values.endorsement_revision)
      form.append("EndorsementTitle", values.endorsement_title)
      form.append("IssuedTime", values.issued_time)
      form.append("ValidFrom", values.valid_from)
      form.append("ValidUntil", values.valid_until)
      form.append("Price", values.price)
  
      return ApiService.fetch(`insurances/${insuranceId}/endorsements/upload_and_store_endorsement`, HTTPMethod.POST, form, false)
    }
}

export default new PolicyManagementImpersonationApi()